export default __webpack_public_path__ + "meetingroomautticket2.json";